import { select } from '@ngneat/elf';

import { appStore } from './app.store';

export const appSelector = {
	backgroundLoading$: appStore.pipe(select((state) => state.backgroundLoadingCounter > 0 && state.loadingCounter === 0)),
	overlayLoading$: appStore.pipe(select((state) => state.loadingCounter > 0)),
  	loadingCounter$: appStore.pipe(select((state) => state.loadingCounter)),
};
